import React from 'react';
import './Spinner.css';

const Spinner = ({ 
  size = 'md', 
  variant = 'primary',
  className = '',
  label = '',
  ...props 
}) => {
  const sizes = {
    xs: 'w-3 h-3 border-2',
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
    xl: 'w-16 h-16 border-4'
  };

  const variants = {
    primary: 'border-[#2563EB] border-t-transparent',
    secondary: 'border-[#0F172A] border-t-transparent',
    white: 'border-white/30 border-t-white',
    whatsapp: 'border-[#25D366]/30 border-t-[#25D366]',
    // gradient removed purple
    // gradient: 'border-transparent border-t-[#2563EB] border-r-[#7C3AED]', // ❌ REMOVED
    gradient: 'border-[#2563EB]/30 border-t-[#2563EB] border-r-[#2563EB]', // changed to blue only
    // neon removed - had purple
    // neon: 'border-transparent border-t-[#EC4899] border-r-[#8B5CF6]', // ❌ REMOVED
    success: 'border-[#10B981]/30 border-t-[#10B981]'
  };

  return (
    <div className="spinner-container">
      <div 
        className={`spinner rounded-full ${sizes[size]} ${variants[variant]} ${className}`}
        {...props}
      />
      {label && <p className="spinner-label">{label}</p>}
    </div>
  );
};

export default Spinner;